<template>
  <ul class="breadcrumbs uk-breadcrumb" v-if="hasBreadcrumbs">
    <li>
      <router-link :to="{ name: 'home' }" key="home">
        Dashboard
      </router-link>
    </li>
    <li v-for="breadcrumb in orderedBreadcrumbs" :key="breadcrumb.id"
        :class="{ 'uk-disabled': isDisabledItem(breadcrumb) }">
      <router-link :to="getRoute(breadcrumb)" v-if="getRoute(breadcrumb)">
        {{getText(breadcrumb)}}
      </router-link>
      <span v-else>
        {{getText(breadcrumb)}}
      </span>
    </li>
  </ul>
</template>

<script>
import isFunction from 'lodash/isFunction';
import { mapState } from 'vuex';

export default {
  name: 'breadcrumbs',
  computed: {
    hasBreadcrumbs() {
      return this.orderedBreadcrumbs.length > 0;
    },
    orderedBreadcrumbs() {
      const breadcrumbs = [];
      this.$route.matched.forEach((route) => {
        const component = route.components.default;
        const view = component.name;
        const breadcrumbsForComponent = this.breadcrumbs[view] || [];
        breadcrumbsForComponent.forEach((breadcrumb) => {
          const id = `breadcrumb:${view}:${breadcrumb.key}`;
          breadcrumbs.push({ view, id, ...breadcrumb });
        });
      });
      return breadcrumbs;
    },
    ...mapState(['breadcrumbs']),
  },
  methods: {
    getText(breadcrumb) {
      if (breadcrumb.isLoading) return this.$t('loading');
      let text = breadcrumb.text;
      if (isFunction(text)) text = text.apply(this);
      return text;
    },
    getRoute(breadcrumb) {
      if (breadcrumb.isLoading) return null;
      let route = breadcrumb.route;
      if (isFunction(route)) route = route.apply(this);
      return route;
    },
    isDisabledItem(breadcrumb) {
      return breadcrumb.disabled || !this.getRoute(breadcrumb);
    },
  },
  i18n: {
    messages: {
      de: {
        loading: 'Lade…',
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumbs {
  user-select: none;
}
</style>



// WEBPACK FOOTER //
// Breadcrumbs.vue?0aabcc28